module.exports = __webpack_public_path__ + "img/icon-inactive.03233d41.svg";